// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"974e9833bcc40100","3847":"8c814f17defc9366"}[chunkId] + ".css";
};